const mobileProductLayout = window.matchMedia('(max-width: 749px)');

function arrangeProductMedia(scope = document) {
  scope.querySelectorAll('.product-information').forEach((section) => {
    const grid = section.querySelector('[data-product-grid-content]');
    const mediaColumn = section.querySelector('.product-information__media');
    const details = section.querySelector('.product-details');
    const demonstration = section.querySelector('.product-information__secondary-media');

    if (!grid || !mediaColumn || !details || !demonstration) return;

    if (mobileProductLayout.matches) {
      details.insertAdjacentElement('afterend', demonstration);
    } else {
      mediaColumn.append(demonstration);
    }
  });
}

arrangeProductMedia();
mobileProductLayout.addEventListener('change', () => arrangeProductMedia());
document.addEventListener('shopify:section:load', (event) => arrangeProductMedia(event.target));
